module.exports = __webpack_public_path__ + "img/iconXMarkRed.d927ad6f.svg";